<template>
    <div class="af-jobview-container afu-bg-gray-100 afu-flex afu-flex-wrap afu-py-12">
        {{ $t('label.not_found') }}
    </div>
</template>

<script>
    export default {
        name: 'JobViewNotFound',

        data() {
            return {
            };
        },

    };
</script>
